"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ApplicationVersion = void 0;
var _tsRes = require("ts-res"),
  _utilities = require("../../utilities"),
  _kameleoonData = require("../../kameleoonData");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var ApplicationVersion = /*#__PURE__*/function () {
  function ApplicationVersion(a) {
    _classCallCheck(this, ApplicationVersion);
    var b = a.version,
      c = a.versionMatchType;
    _defineProperty(this, "conditionValue", void 0), _defineProperty(this, "versionMatchType", void 0), this.conditionValue = b, this.versionMatchType = c;
  }
  return _createClass(ApplicationVersion, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b;
      var c = a.targetingData;
      var d = null === c || void 0 === c || null === (b = c[_kameleoonData.KameleoonData.ApplicationVersion]) || void 0 === b ? void 0 : b.version;
      if (!d || !this.conditionValue || !this.versionMatchType) return (0, _tsRes.Ok)(!1);
      var e = _utilities.Utilities.compareSemVer({
        version: d,
        compareVersion: this.conditionValue,
        operator: this.versionMatchType
      });
      return e.ok ? (0, _tsRes.Ok)(e.data) : (0, _tsRes.Err)(e.error);
    }
  }]);
}();
exports.ApplicationVersion = ApplicationVersion;